























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import Arrow from '@/components/icons/Arrow.vue';
import GhostButton from '@/components/molecules/GhostButton/GhostButton.vue';

import { ICampaignOption } from '@/models/performance';

import RadioGroup, {
  IRadioGroup
} from '@/componentsV2/molecules/RadioGroup/RadioGroup.vue';

@Component({
  components: {
    RadioGroup,
    GhostButton,
    Arrow
  }
})
export default class FilterByCampaigns extends Vue {
  @Prop() campaignsOptions!: ICampaignOption[];
  @Prop() initSelectedCampaign!: string;
  @Prop() linkSeeAll!: string;
  @Prop() campaignTitle?: string;

  goToCampaigns() {
    if (this.campaignTitle) {
      this.$analytics({
        eventAction: 'click',
        eventCategory: `Activities Overview - ${this.campaignTitle}`,
        eventLabel: 'See all campaigns'
      });
    }

    this.$router.push(this.linkSeeAll);
  }

  handleCampaign(campaign: any) {
    this.$emit('handleFilterByCampaign', campaign);
  }

  handleClickFilterByCampaign(campaign: any) {
    if (this.campaignTitle) {
      this.$analytics({
        eventAction: 'click',
        eventCategory: `Activities Overview - ${this.campaignTitle} - Filter`,
        eventLabel: campaign
      });
    }
  }
}
